import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { PolicyBenefitLimit } from '@models/PolicyBenefitLimit';

export type GetAllPolicyBenefitLimitParams = {
  policyBenefitTemplateId: number;
};

export class PolicyBenefitLimitApi {
  static getAll = async (params: GetAllPolicyBenefitLimitParams) => {
    return await authAxios.get(`${API_V1_BASE}/user/policy_benefit_limits`, { params: snakes(params) }).then((response) => humps(response.data) as PolicyBenefitLimit[]);
  };
}
